import { render, staticRenderFns } from "./purchase-order-sales.vue?vue&type=template&id=705ec2ea&scoped=true&"
import script from "./purchase-order-sales.vue?vue&type=script&lang=js&"
export * from "./purchase-order-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ec2ea",
  null
  
)

export default component.exports